import {
  TGetFacebookOrInstagramAuthorizedPagesPayload,
  TDeleteConnectedSocialAccountPayload,
  TPostChoosePageFromTheListReturnedByGetLinkedinAuthorizedPagesPayload,
  TGetLinkedinAuthorizationLinkPayload,
  TGetLinkedinAuthorizedPagesPayload,
  TPostChoosePageFromTheListReturnedByGetFacebookAuthorizedPagesPayload,
  TGetTwitterAuthorizationLinkResponsePayload,
  TPostSetTwitterUserAccessTokenPayload,
  TGetDailyInsightsBySocialNetworkAndMetricPayload,
  TSaveProjectSettingsPayload,
  TGetRemoveUserRolesFromProjectPayload,
  TGetSummaryInsightsBySocialNetworkAndMetricPayload,
  TGetProjectIdLinkedToTwitterRequestOauthToken,
  TUpdateUserSettingPayload
} from './types'
import axios, { AxiosResponse } from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { RootState } from '..'
import { removeSocialAccountFromProjectsAction } from '../agency/slice'

export const createProjectThunk = createAsyncThunk(
  'agency/createProjectThunk',
  async (data: any, { rejectWithValue }) => {
    try {
      const response: AxiosResponse<any> = await axios.post(`/projects`, data)
      return response.data.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const updateProjectThunk = createAsyncThunk(
  'agency/updateProjectThunk',
  async (data: FormData | TUpdateProjectPayload, { rejectWithValue, getState }) => {
    const {
      project: { currentProject }
    } = getState() as RootState

    try {
      const response: AxiosResponse<any> = await axios.post(`/projects/${currentProject.id}`, data)
      return response.data.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const softDeleteProjectThunk = createAsyncThunk(
  'agency/softDeleteProjectThunk',
  async (data, { rejectWithValue, getState, dispatch }) => {
    const {
      project: { currentProject }
    } = getState() as RootState

    try {
      const response: AxiosResponse<any> = await axios.delete(`/projects/${currentProject.id}`)
      return currentProject.id
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const inviteToProjectThunk = createAsyncThunk(
  'agency/inviteToProjectThunk',
  async (data: any, { rejectWithValue }) => {
    try {
      const response: AxiosResponse<any> = await axios.post(`/userinvitations/project/send`, data)
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const getProjectUsersByRoleThunk = createAsyncThunk(
  'approval/getProjectUsersByRoleThunk',
  async (data, { dispatch, getState, rejectWithValue }) => {
    const {
      project: {
        currentProject: { id: project_id }
      }
    } = getState() as RootState
    try {
      const responseUsers: AxiosResponse<any> = await axios.get(`projects/${project_id}/users`)
      return responseUsers.data.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const getFacebookAuthorizedPagesThunk = createAsyncThunk(
  'agency/getFacebookAuthorizedPagesThunk',
  async (
    { project_id, token }: TGetFacebookOrInstagramAuthorizedPagesPayload,
    { dispatch, rejectWithValue }
  ) => {
    try {
      const facebookAuthorizedPages: AxiosResponse<any> = await axios.get(
        `/projects/${project_id}/facebook/pages`,
        {
          params: {
            token
          }
        }
      )
      return facebookAuthorizedPages.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const getInstagramAuthorizedPagesThunk = createAsyncThunk(
  'agency/getFacebookAuthorizedPagesThunk',
  async (
    { project_id, token }: TGetFacebookOrInstagramAuthorizedPagesPayload,
    { dispatch, rejectWithValue }
  ) => {
    try {
      const facebookAuthorizedPages: AxiosResponse<any> = await axios.get(
        `/projects/${project_id}/instagram/pages`,
        {
          params: {
            token
          }
        }
      )
      return facebookAuthorizedPages.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const deleteConnectedSocialAccountThunk = createAsyncThunk(
  'agency/deleteConnectedSocialAccountThunk',
  async (
    { project_id, social }: TDeleteConnectedSocialAccountPayload,
    { dispatch, rejectWithValue }
  ) => {
    try {
      const deleteConnectedSocialAccount: AxiosResponse<any> = await axios.delete(
        `/projects/${project_id}/${social}`
      )
      dispatch(removeSocialAccountFromProjectsAction({ project_id, social }))
      return deleteConnectedSocialAccount.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const postChoosePageFromTheListReturnedByGetFacebookAuthorizedPagesThunk = createAsyncThunk(
  'agency/postChoosePageFromTheListReturnedByGetFacebookAuthorizedPagesThunk',
  async (
    data: TPostChoosePageFromTheListReturnedByGetFacebookAuthorizedPagesPayload,
    { dispatch, rejectWithValue }
  ) => {
    try {
      const deleteConnectedSocialAccount: AxiosResponse<any> = await axios.post(
        `/projects/facebook/pages`,
        data
      )
      return deleteConnectedSocialAccount.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const postChoosePageFromTheListReturnedByGetInstagramAuthorizedPagesThunk = createAsyncThunk(
  'agency/postChoosePageFromTheListReturnedByGetFacebookAuthorizedPagesThunk',
  async (
    data: TPostChoosePageFromTheListReturnedByGetFacebookAuthorizedPagesPayload,
    { dispatch, rejectWithValue }
  ) => {
    try {
      const deleteConnectedSocialAccount: AxiosResponse<any> = await axios.post(
        `/projects/instagram/pages`,
        data
      )
      return deleteConnectedSocialAccount.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const getLinkedinAuthorizationLinkThunk = createAsyncThunk(
  'agency/getLinkedinAuthorizationLinkThunk',
  async (
    { project_id, callback_url }: TGetLinkedinAuthorizationLinkPayload,
    { dispatch, rejectWithValue }
  ) => {
    try {
      const deleteConnectedSocialAccount: AxiosResponse<any> = await axios.get(
        `/projects/${project_id}/linkedin/authorization-link?callback_url=${callback_url}`
      )
      return deleteConnectedSocialAccount.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const getLinkedinAuthorizedPagesThunk = createAsyncThunk(
  'agency/getLinkedinAuthorizationLinkThunk',
  async ({ code, state }: TGetLinkedinAuthorizedPagesPayload, { dispatch, rejectWithValue }) => {
    try {
      const deleteConnectedSocialAccount: AxiosResponse<any> = await axios.get(
        `projects/linkedin/pages?code=${code}&state=${state}`
      )
      return deleteConnectedSocialAccount.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const postChoosePageFromTheListReturnedByGetLinkedinAuthorizedPagesThunk = createAsyncThunk(
  'agency/postChoosePageFromTheListReturnedByGetlinkedinAuthorizedPagesThunk',
  async (
    data: TPostChoosePageFromTheListReturnedByGetLinkedinAuthorizedPagesPayload,
    { dispatch, rejectWithValue }
  ) => {
    try {
      const deleteConnectedSocialAccount: AxiosResponse<any> = await axios.post(
        `/projects/linkedin/pages`,
        data
      )
      return deleteConnectedSocialAccount.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const getTwitterAuthorizationLinkResponseThunk = createAsyncThunk(
  'agency/getTwitterAuthorizationLinkResponseThunk',
  async (
    { project_id, callback_url }: TGetTwitterAuthorizationLinkResponsePayload,
    { dispatch, rejectWithValue }
  ) => {
    try {
      const deleteConnectedSocialAccount: AxiosResponse<any> = await axios.get(
        `projects/${project_id}/twitter/authorization-link?callback_url=${callback_url}`
      )
      return deleteConnectedSocialAccount.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const postSetTwitterUserAccessTokenThunk = createAsyncThunk(
  'agency/postSetTwitterUserAccessTokenThunk',
  async (
    { oauth_token, oauth_verifier }: TPostSetTwitterUserAccessTokenPayload,
    { dispatch, rejectWithValue }
  ) => {
    try {
      const deleteConnectedSocialAccount: AxiosResponse<any> = await axios.post(
        `projects/twitter/access-token`,
        { oauth_token, oauth_verifier }
      )
      return deleteConnectedSocialAccount.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const getProjectIdLinkedToTwitterRequestOauthTokenThunk = createAsyncThunk(
  'agency/getProjectIdLinkedToTwitterRequestOauthTokenThunk',
  async (
    { oauth_token }: TGetProjectIdLinkedToTwitterRequestOauthToken,
    { dispatch, rejectWithValue }
  ) => {
    try {
      const deleteConnectedSocialAccount: AxiosResponse<any> = await axios.get(
        `projects/twitter/${oauth_token}`
      )
      return deleteConnectedSocialAccount.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const getPostsForApprovalThunk = createAsyncThunk(
  'approval/getPostsForApproval',
  async (data, { dispatch, rejectWithValue, getState }) => {
    const {
      project: {
        currentProject: { id }
      }
    } = getState() as RootState
    try {
      const responseUserData: AxiosResponse<any> = await axios.get(
        `projects/${id}/posts/pending-approval`
      )
      return responseUserData.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const getApprovedPostsThunk = createAsyncThunk(
  'approval/getApprovedPosts',
  async (data, { dispatch, rejectWithValue, getState }) => {
    const {
      project: {
        currentProject: { id }
      }
    } = getState() as RootState
    try {
      const responseUserData: AxiosResponse<any> = await axios.get(
        `projects/${id}/posts/approved`
      )
      return responseUserData.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)


export const getDailyInsightsBySocialNetworkAndMetricThunk = createAsyncThunk(
  'agency/getDailyInsightsBySocialNetworkAndMetric',
  async (
    {
      project_id,
      social_network,
      metrics,
      from,
      to,
      interval
    }: TGetDailyInsightsBySocialNetworkAndMetricPayload,
    { dispatch, rejectWithValue }
  ) => {
    try {
      const facebookAuthorizedPages: AxiosResponse<any> = await axios.get(
        `/insights/${social_network}/project-daily-insights/${project_id}`,
        {
          params: {
            metrics,
            from,
            to,
            interval
          }
        }
      )
      return facebookAuthorizedPages.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const getSummaryInsightsBySocialNetworkAndMetricThunk = createAsyncThunk(
  'agency/getDailyInsightsBySocialNetworkAndMetric',
  async (
    { project_id, social_network, metrics }: TGetSummaryInsightsBySocialNetworkAndMetricPayload,
    { dispatch, rejectWithValue }
  ) => {
    try {
      const facebookAuthorizedPages: AxiosResponse<any> = await axios.get(
        `/insights/${social_network}/project-summary-insights/${project_id}`,
        {
          params: {
            metrics
          }
        }
      )
      return facebookAuthorizedPages.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const getAvailableMetricsBySocialNetworkThunk = createAsyncThunk(
  'agency/getAvailableMetricsBySocialNetwork',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const facebookAuthorizedPages: AxiosResponse<any> = await axios.get(
        `insights/daily-insights-metrics`
      )
      return facebookAuthorizedPages.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const getAllProjectSettings = createAsyncThunk(
  'agency/getAllProjectSettings',
  async (project_id: number, { dispatch, rejectWithValue }) => {
    try {
      const facebookAuthorizedPages: AxiosResponse<any> = await axios.get(
        `/projects/${project_id}/settings`
      )
      return facebookAuthorizedPages.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const saveProjectSettings = createAsyncThunk(
  'agency/getAllProjectSettings',
  async ({ project_id, settings }: TSaveProjectSettingsPayload, { dispatch, rejectWithValue }) => {
    try {
      const facebookAuthorizedPages: AxiosResponse<any> = await axios.post(
        `/projects/${project_id}/settings`,
        {
          settings
        }
      )
      return facebookAuthorizedPages.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const removeUserRolesFromProjectThunk = createAsyncThunk(
  'agency/removeUserRolesFromProjectThunk',
  async (
    { project_id, user_id }: TGetRemoveUserRolesFromProjectPayload,
    { dispatch, rejectWithValue }
  ) => {
    try {
      const facebookAuthorizedPages: AxiosResponse<any> = await axios.get(
        `/projects/${project_id}/remove/user/${user_id}`
      )
      return facebookAuthorizedPages.data
    } catch (err) {
      return rejectWithValue((err as any).response.data)
    }
  }
)

export const updateUserSettingFromProjectThunk = createAsyncThunk(
  'project/updateUserSettingFromProjectThunk',
  async (data:TUpdateUserSettingPayload,{rejectWithValue}) => {
   try{
    const updateUserSetting: AxiosResponse<any> = await axios.post(
      `/projects/${data.project_id}/settings/${data.user_id}`,
      {...data.payload}
    )
    return updateUserSetting.data.data
   } catch(err){
      return rejectWithValue((err as any).response.data)
   }
  }
)

export const getTopPerformanceThunk= createAsyncThunk(
  'project/getTopPerformanceThunk',
  async (data:{projectId:number, social:string, type: string},{rejectWithValue}) => {
   try{
    const urlType = data.type === 'reach'?'top-post-insight-details':'top-post-total-insight-details'
    const response: AxiosResponse<any> = await axios.get(
      `/insights/${data.social}/${urlType}/${data.projectId}`,
    )
    return data.type === 'reach'? response.data.data.reachResult: response.data.data.totalResult
   } catch(err){
      return rejectWithValue((err as any).response.data)
   }
  }
)

export type TUpdateProjectPayload = {
  name?: string
  timezone?: string
  image?: File
}
